import React from "react";

export default function WomensDayFrame3({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {
              ".clsw3-1{fill:#ffad58}.clsw3-2{fill:#693b48}.clsw3-3{fill:#ff5642}.clsw3-4{fill:#fd5940}"
            }
          </style>
        </defs>
        <path
          className="clsw3-2"
          d="M1283.25 1562.96H658.94c-66.28 0-128.59-25.81-175.46-72.68s-72.68-109.18-72.68-175.46V478.14c0-66.28 25.81-128.59 72.68-175.46C530.35 255.81 592.66 230 658.94 230h624.31c66.28 0 128.59 25.81 175.46 72.68 46.87 46.87 72.68 109.18 72.68 175.46v836.69c0 66.28-25.81 128.59-72.68 175.46-46.87 46.87-109.18 72.68-175.46 72.68ZM658.94 246c-128 0-232.14 104.14-232.14 232.14v836.69c0 128 104.14 232.14 232.14 232.14h624.31c128 0 232.14-104.14 232.14-232.14V478.14c0-128-104.14-232.14-232.14-232.14H658.94Z"
        />
        <path
          className="clsw3-1"
          d="M1223.39 1517.33c-8.06-9.28-65.15-76.27-52.27-124.64 1.44-5.42 5.07-19.06 15.9-24.96 14.56-7.93 34.07 2.54 42.49 10.5 22.78 21.58 19.73 77.51-6.12 139.09ZM1338.3 1400.27c-6.72-6.67-54.39-54.88-47.03-93.22.82-4.29 2.9-15.11 10.95-20.39 10.82-7.09 26.46-.25 33.38 5.38 18.75 15.24 19.38 58.8 2.7 108.23ZM1405.9 1262.91c-5.67-6.2-45.84-50.97-37.82-84.37.9-3.74 3.16-13.17 10.48-17.42 9.84-5.72 23.36 1.06 29.25 6.35 15.95 14.33 14.77 52.73-1.91 95.45ZM1451.76 1122.05c-5.57-7.43-44.94-61-32.83-96.32 1.36-3.96 4.77-13.92 13.19-17.65 11.31-5.01 25.41 4.01 31.31 10.49 15.97 17.53 10.84 59.1-11.67 103.48ZM1454.04 1218.6c3.22-7.91 26.74-64.25 58.25-66.64 3.53-.27 12.42-.94 18.75 5.32 8.51 8.42 7.68 24.72 5.32 32.57-6.4 21.26-39.66 32.4-82.32 28.76ZM1394.06 1366.61c5.87-6.67 48.28-53.9 81.26-43.77 3.69 1.13 13 3.99 17.42 12.8 5.95 11.84-.21 27.89-5.19 34.84-13.47 18.81-51.09 16.77-93.5-3.87ZM1292.64 1495.08c8.6-4.28 70.43-34.18 101.43-9.05 3.47 2.82 12.22 9.91 13.66 20.97 1.94 14.87-10.39 28.7-18.16 33.66-21.02 13.43-59.86-5.41-96.94-45.58Z"
        />
        <path
          className="clsw3-1"
          d="M1187.68 1557.64c-.52 0-1.03-.27-1.3-.76a1.49 1.49 0 0 1 .56-2.04c58.14-33.06 164.48-110.42 223.43-257.09 26.08-64.9 39.73-134.95 40.57-208.21 0-.83.7-1.47 1.52-1.48.83 0 1.49.69 1.48 1.52-.84 73.63-14.57 144.05-40.79 209.29-59.28 147.51-166.25 225.33-224.73 258.58-.23.13-.49.2-.74.2Z"
        />
        <path
          className="clsw3-4"
          d="M977.41 1528.16c-1.82-1.34-14.77-11.08-14.4-20.28.04-1.03.14-3.63 1.85-5.12 2.3-2.01 6.22-.92 8.05.18 4.96 2.96 6.66 13.13 4.5 25.22ZM993.34 1502.52c-1.48-.93-11.98-7.67-12.2-14.85-.02-.8-.09-2.83 1.15-4.1 1.66-1.71 4.74-1.11 6.21-.38 3.98 1.98 5.85 9.78 4.84 19.33ZM999.96 1475.13c-1.27-.88-10.28-7.31-10.19-13.63.01-.71.04-2.49 1.18-3.55 1.54-1.42 4.24-.75 5.51-.04 3.44 1.93 4.77 8.87 3.5 17.22ZM1002.53 1447.99c-1.3-1.11-10.52-9.15-9.77-15.98.08-.76.3-2.69 1.66-3.7 1.83-1.36 4.72-.3 6.04.62 3.57 2.51 4.32 10.18 2.07 19.05ZM1006.82 1465.23c.26-1.55 2.22-12.61 7.78-14.31.62-.19 2.19-.67 3.58.2 1.87 1.17 2.37 4.13 2.27 5.63-.29 4.07-5.82 7.41-13.63 8.48ZM1002 1494.23c.79-1.43 6.5-11.62 12.83-11.13.71.06 2.5.19 3.64 1.6 1.54 1.89 1.08 5.02.47 6.46-1.66 3.92-8.5 5.07-16.95 3.07ZM988.96 1521.38c1.37-1.11 11.27-8.97 17.85-5.7.74.37 2.59 1.29 3.3 3.22.95 2.59-.71 5.57-1.91 6.78-3.24 3.26-10.97 1.44-19.24-4.29Z"
        />
        <path
          className="clsw3-4"
          d="m973.23 1537.31-1.34-1.48c9.04-8.21 24.91-26.24 29.56-54.74 2.06-12.61 1.7-25.65-1.08-38.76l1.96-.41c2.83 13.35 3.2 26.63 1.1 39.49-4.75 29.09-20.95 47.51-30.19 55.9ZM905.76 1573.86c2.9 2.67 23.46 21.98 18.55 35.73-.55 1.54-1.94 5.42-5.92 7.06-5.35 2.21-12.43-.84-15.47-3.14-8.23-6.23-6.87-22.17 2.84-39.65ZM863.27 1606.85c2.43 1.92 19.63 15.84 16.77 26.75-.32 1.22-1.13 4.3-4.09 5.78-3.98 1.99-9.66-.02-12.17-1.65-6.78-4.41-6.82-16.84-.51-30.88ZM837.98 1645.8c2.04 1.79 16.52 14.69 13.44 24.19-.34 1.06-1.21 3.74-3.9 4.93-3.62 1.6-8.53-.38-10.66-1.91-5.76-4.14-5.17-15.09 1.12-27.22ZM820.62 1685.82c2 2.14 16.15 17.55 11.57 27.58-.51 1.12-1.8 3.95-4.89 4.99-4.15 1.39-9.26-1.23-11.39-3.1-5.76-5.05-3.7-16.89 4.72-29.48ZM820.2 1658.27c-1.21 2.25-10.05 18.23-21.57 18.81-1.29.06-4.54.23-6.82-1.58-3.07-2.43-2.7-7.08-1.8-9.31 2.43-6.04 14.63-9.11 30.19-7.92ZM842.76 1616.26c-2.17 1.88-17.87 15.21-29.87 12.21-1.34-.34-4.73-1.18-6.31-3.71-2.12-3.4.2-7.95 2.05-9.92 5-5.32 18.73-4.61 34.13 1.42ZM880.37 1579.97c-3.16 1.19-25.88 9.51-37.09 2.23-1.26-.81-4.42-2.87-4.9-6.03-.64-4.25 3.92-8.15 6.78-9.54 7.74-3.76 21.84 1.75 35.21 13.33Z"
        />
        <path
          className="clsw3-4"
          d="m821.23 1695.11-2-.06c.63-21.1 5.98-41.23 15.89-59.84 22.38-42.02 61.9-63.91 83.46-73.22l.79 1.84c-21.32 9.21-60.4 30.84-82.49 72.32-9.77 18.33-15.03 38.17-15.66 58.96Z"
        />
        <path
          className="clsw3-1"
          d="M715.73 1534.31c8.06-9.28 65.15-76.27 52.27-124.64-1.44-5.42-5.07-19.06-15.9-24.96-14.56-7.93-34.07 2.54-42.49 10.5-22.78 21.58-19.73 77.51 6.12 139.09ZM600.82 1417.26c6.72-6.67 54.39-54.88 47.03-93.22-.82-4.29-2.9-15.11-10.95-20.39-10.82-7.09-26.46-.25-33.38 5.38-18.75 15.24-19.38 58.8-2.7 108.23ZM533.22 1279.89c5.67-6.2 45.84-50.97 37.82-84.37-.9-3.74-3.16-13.17-10.48-17.42-9.84-5.72-23.36 1.06-29.25 6.35-15.95 14.33-14.77 52.73 1.91 95.45ZM487.36 1139.03c5.57-7.43 44.94-61 32.83-96.32-1.36-3.96-4.77-13.92-13.19-17.65-11.31-5.01-25.41 4.01-31.31 10.49-15.97 17.53-10.84 59.1 11.67 103.48ZM485.08 1235.59c-3.22-7.91-26.74-64.25-58.25-66.64-3.53-.27-12.42-.94-18.75 5.32-8.51 8.42-7.68 24.72-5.32 32.57 6.4 21.26 39.66 32.4 82.32 28.76ZM545.06 1383.6c-5.87-6.67-48.28-53.9-81.26-43.77-3.69 1.13-13 3.99-17.42 12.8-5.95 11.84.21 27.89 5.19 34.84 13.47 18.81 51.09 16.77 93.5-3.87ZM646.48 1512.06c-8.6-4.28-70.43-34.18-101.43-9.05-3.47 2.82-12.22 9.91-13.66 20.97-1.94 14.87 10.39 28.7 18.16 33.66 21.02 13.43 59.86-5.41 96.94-45.58Z"
        />
        <path
          className="clsw3-1"
          d="M751.44 1574.63c-.25 0-.51-.06-.74-.2-58.48-33.25-165.45-111.06-224.73-258.58-26.22-65.24-39.94-135.66-40.79-209.29 0-.83.65-1.51 1.48-1.52.86-.02 1.51.65 1.52 1.48.84 73.26 14.49 143.31 40.57 208.21 58.95 146.67 165.29 224.03 223.43 257.09.72.41.97 1.33.56 2.04-.28.49-.78.76-1.3.76Z"
        />
        <path
          className="clsw3-2"
          d="M1254.82 1499.94c-11.04-16.22-88.96-133.17-59.45-207.44 3.3-8.32 11.63-29.27 29.91-36.58 24.57-9.83 53.55 10.43 65.39 24.64 32.06 38.49 16.72 126.6-35.85 219.38ZM1459.02 1335.95c-9.4-11.83-75.93-97.24-57.05-156.64 2.11-6.65 7.44-23.41 21.2-30.26 18.49-9.21 41.99 4.57 51.92 14.8 26.86 27.69 19.67 96.88-16.07 172.11ZM1592.01 1130.86c-7.82-10.89-63.1-89.43-44.1-140.89 2.13-5.76 7.49-20.28 19.89-25.65 16.67-7.22 36.85 6.07 45.19 15.57 22.59 25.72 13.51 86.37-20.98 150.97ZM1691.21 916.15c-7.43-12.82-59.78-105.17-33.94-158.89 2.89-6.02 10.18-21.17 24.23-25.5 18.88-5.82 39.53 11.14 47.67 22.51 22.03 30.8 6.08 95.75-37.96 161.88ZM1676.68 1069.67c6.59-11.94 54.47-96.84 104.89-94.71 5.65.24 19.87.84 28.72 11.96 11.91 14.95 7.53 40.64 2.31 52.64-14.14 32.5-68.97 43.92-135.92 30.12ZM1553.76 1293.06c10.55-9.47 86.68-76.39 137.07-54.12 5.64 2.49 19.86 8.78 25.22 23.57 7.21 19.89-5.58 44.18-14.77 54.26-24.89 27.29-84.16 16.99-147.51-23.71ZM1368.8 1477.69c14.44-5.16 118.1-40.96 162.52 4.72 4.98 5.12 17.51 18 17.72 35.81.28 23.95-21.87 43.56-35.11 49.96-35.86 17.34-93.88-19.83-145.12-90.5Z"
        />
        <path
          className="clsw3-2"
          d="M1190.9 1557.77c-1.17 0-2.28-.69-2.77-1.84-.64-1.53.07-3.29 1.6-3.93 98.33-41.46 281.34-144.05 402.29-365.36 53.52-97.92 88.3-206.35 103.4-322.28.21-1.64 1.72-2.8 3.36-2.59 1.64.21 2.8 1.72 2.59 3.36-15.19 116.67-50.21 225.81-104.08 324.38-56.33 103.08-131.72 191.3-224.07 262.24-56.3 43.24-117.25 78.83-181.15 105.77-.38.16-.78.24-1.16.24ZM687.36 1515.09c11.04-16.22 88.96-133.17 59.45-207.44-3.3-8.32-11.63-29.27-29.91-36.58-24.57-9.83-53.55 10.43-65.39 24.64-32.06 38.49-16.72 126.6 35.85 219.38ZM483.16 1351.11c9.4-11.83 75.93-97.24 57.05-156.64-2.11-6.65-7.44-23.41-21.2-30.26-18.49-9.21-41.99 4.57-51.92 14.8-26.86 27.69-19.67 96.88 16.07 172.11ZM350.17 1146.02c7.82-10.89 63.1-89.43 44.1-140.89-2.13-5.76-7.49-20.28-19.89-25.65-16.67-7.22-36.85 6.07-45.19 15.57-22.59 25.72-13.51 86.37 20.98 150.97ZM250.97 931.3c7.43-12.82 59.78-105.17 33.94-158.89-2.89-6.02-10.18-21.17-24.23-25.5-18.88-5.82-39.53 11.14-47.67 22.51-22.03 30.8-6.08 95.75 37.96 161.88ZM265.5 1084.82c-6.59-11.94-54.47-96.84-104.89-94.71-5.65.24-19.87.84-28.72 11.96-11.91 14.95-7.53 40.64-2.31 52.64 14.14 32.5 68.97 43.92 135.92 30.12ZM388.42 1308.22c-10.55-9.47-86.68-76.39-137.07-54.12-5.64 2.49-19.86 8.78-25.22 23.57-7.21 19.89 5.58 44.18 14.77 54.26 24.89 27.29 84.16 16.99 147.51-23.71ZM573.38 1492.84c-14.44-5.16-118.1-40.96-162.52 4.72-4.98 5.12-17.51 18-17.72 35.81-.28 23.95 21.87 43.56 35.11 49.96 35.86 17.34 93.88-19.83 145.12-90.5Z"
        />
        <path
          className="clsw3-2"
          d="M751.28 1572.93c-.39 0-.78-.08-1.16-.24-63.91-26.94-124.86-62.53-181.15-105.77-92.35-70.93-167.74-159.16-224.07-262.24-53.87-98.58-88.89-207.72-104.08-324.38-.21-1.64.94-3.15 2.59-3.36a2.99 2.99 0 0 1 3.36 2.59c15.09 115.92 49.88 224.35 103.4 322.28 120.94 221.31 303.96 323.9 402.29 365.36 1.53.64 2.24 2.4 1.6 3.93a2.993 2.993 0 0 1-2.77 1.83Z"
        />
        <path
          className="clsw3-4"
          d="M1090.35 1655.51c0 33.59-12.12 59.74-36.36 78.44-24.24 18.7-52.88 28.05-85.93 28.05s-60.28-8.99-83.88-26.96c-23.6-17.97-35.41-43.12-35.41-75.44 0-21.24 6.72-40.81 20.15-58.69 13.43-17.88 32.59-32.09 57.47-42.62v-3c-37.4-23.06-56.1-51.56-56.1-85.52 0-27.23 9.98-48.29 29.96-63.18 19.97-14.89 43.75-22.33 71.35-22.33s50.15 7.08 69.86 21.24c19.7 14.16 29.55 33.59 29.55 58.28 0 16.89-5.27 33.05-15.8 48.48-10.53 15.43-25.15 26.96-43.85 34.59v3c52.65 29.6 78.98 64.82 78.98 105.67Zm-39.81 16.02c6.9-33.44-11.2-59.21-15.62-65.51-26.28-37.44-70.97-40.46-77.22-40.78-9.97 3.24-32.8 12.22-50.32 35.14-12.98 16.98-16.67 33.26-17.35 36.44-1.98 9.21-6.46 37.47 9.54 62.47 19.86 31.02 63.56 44.97 99.78 31.24 2.08-.79 42.51-16.91 51.19-59Zm-22.83-201.76c0-17.61-5.68-31.09-17.02-40.44-11.35-9.35-24.92-14.03-40.72-14.03s-28.23 4.13-39.49 12.39c-11.26 8.26-16.89 19.47-16.89 33.63 0 29.41 21.52 54.38 64.55 74.9 33.04-14.71 49.57-36.86 49.57-66.45Z"
        />
        <path
          className="clsw3-2"
          d="M1115.81 1587.13c1.29-4.36 11.58-41.06-8.24-60.05-1.22-1.17-13.21-12.4-22.76-8.5-9.04 3.68-10.9 18.87-9.82 27.84 3.24 26.86 37.96 39.7 40.83 40.72Z"
        />
        <path
          className="clsw3-3"
          d="M1115.95 1587.18c3.82-2.47 35.57-23.54 32.96-50.87-.16-1.68-1.92-18.01-11.69-21.3-9.25-3.11-20.58 7.18-25.61 14.67-15.08 22.46 2.84 54.86 4.34 57.5Z"
        />
        <path
          className="clsw3-2"
          d="M1115.81 1587.13c1.4-4.33 13.59-40.43 40.67-44.94 1.67-.28 17.9-2.79 23.59 5.81 5.39 8.14-1.64 21.73-7.58 28.53-17.82 20.36-53.74 11.38-56.68 10.61Z"
        />
        <circle className="clsw3-2" cx={1110.23} cy={1512.58} r={3.4} />
        <circle className="clsw3-2" cx={1159.49} cy={1527.8} r={3.4} />
        <circle className="clsw3-2" cx={1140} cy={1503.55} r={3.4} />
        <path
          className="clsw3-2"
          d="M432.34 909.73c-.41-10.05-4.94-94.17-61.12-118.16-3.46-1.48-37.25-15.44-54.88.06-16.68 14.67-9.68 47.62-.87 65.38 26.38 53.2 109.99 52.84 116.87 52.72Z"
        />
        <path
          className="clsw3-3"
          d="M432.66 909.71c6.4-8.09 59.09-76.5 33.71-131.16-1.56-3.37-17.14-35.88-40.45-35.1-22.05.74-38.85 30.89-44.2 50.36-16.02 58.33 45.79 111.59 50.93 115.9Z"
        />
        <path
          className="clsw3-2"
          d="M432.34 909.73c-.14-10.07-.19-94.45 54.5-124.86 3.37-1.87 36.29-19.7 54.71-6.29 17.43 12.69 12.24 46.35 4.42 65.07-23.4 56.09-106.77 65.41-113.63 66.08Z"
        />
        <ellipse
          className="clsw3-2"
          cx={366.41}
          cy={759.43}
          rx={7.75}
          ry={7.46}
          transform="rotate(-29.4 366.336 759.353)"
        />
        <ellipse
          className="clsw3-2"
          cx={482.86}
          cy={752.68}
          rx={7.75}
          ry={7.46}
          transform="rotate(-29.4 482.774 752.6)"
        />
        <ellipse
          className="clsw3-2"
          cx={423.59}
          cy={717.53}
          rx={7.75}
          ry={7.46}
          transform="rotate(-29.4 423.508 717.456)"
        />
        <path
          className="clsw3-3"
          d="M1551.07 849.55c-3.1-7.33-29.85-68.34-78.1-70.48-2.97-.13-31.87-1.07-40.61 15.31-8.27 15.5 6.08 37.95 17.54 48.65 34.32 32.05 96.12 8.53 101.18 6.53Z"
        />
        <path
          className="clsw3-1"
          d="M1551.3 849.45c2.49-7.77 22.47-73.07-11.51-106.47-2.09-2.06-22.67-21.79-39.7-14.74-16.12 6.68-20.17 33.67-18.72 49.57 4.36 47.63 64.93 69.88 69.93 71.64Z"
        />
        <path
          className="clsw3-3"
          d="M1551.07 849.55c-2.9-7.42-26.41-69.87 5.63-107.6 1.97-2.33 21.39-24.68 38.75-19.87 16.43 4.55 21.95 30.91 21.37 46.95-1.73 48.03-60.86 78.11-65.75 80.52Z"
        />
        <ellipse
          className="clsw3-3"
          cx={1460.47}
          cy={756.62}
          rx={6.13}
          ry={5.9}
          transform="rotate(-49.98 1460.576 756.62)"
        />
        <ellipse
          className="clsw3-3"
          cx={1544.79}
          cy={719.24}
          rx={6.13}
          ry={5.9}
          transform="rotate(-49.98 1544.908 719.238)"
        />
        <ellipse
          className="clsw3-3"
          cx={1491.14}
          cy={709.7}
          rx={6.13}
          ry={5.9}
          transform="rotate(-49.98 1491.246 709.7)"
        />
        <path
          className="clsw3-3"
          d="M801.81 1592.11c-1.89-4.46-18.17-41.61-47.55-42.91-1.81-.08-19.4-.65-24.72 9.32-5.04 9.44 3.7 23.1 10.68 29.62 20.9 19.51 58.52 5.19 61.6 3.97Z"
        />
        <path
          className="clsw3-1"
          d="M801.95 1592.05c1.51-4.73 13.68-44.49-7.01-64.82-1.28-1.25-13.8-13.27-24.17-8.97-9.82 4.07-12.28 20.5-11.39 30.18 2.66 29 39.53 42.54 42.58 43.62Z"
        />
        <path
          className="clsw3-3"
          d="M801.81 1592.11c-1.77-4.51-16.08-42.54 3.43-65.51 1.2-1.42 13.02-15.03 23.59-12.1 10 2.77 13.36 18.82 13.01 28.58-1.05 29.24-37.05 47.56-40.03 49.02Z"
        />
        <ellipse
          className="clsw3-3"
          cx={746.65}
          cy={1535.53}
          rx={3.73}
          ry={3.59}
          transform="rotate(-49.98 746.736 1535.6)"
        />
        <ellipse
          className="clsw3-3"
          cx={797.99}
          cy={1512.77}
          rx={3.73}
          ry={3.59}
          transform="rotate(-49.98 798.085 1512.84)"
        />
        <ellipse
          className="clsw3-3"
          cx={765.32}
          cy={1506.97}
          rx={3.73}
          ry={3.59}
          transform="rotate(-49.98 765.415 1507.04)"
        />
        <path
          className="clsw3-1"
          d="M1851.05 969.19c2.45-4.97 22.43-46.88 1.57-73.29-1.29-1.63-13.96-17.29-26.58-14.43-11.94 2.7-17.24 20.5-17.65 31.41-1.26 32.7 39.3 54.56 42.66 56.32Z"
        />
        <path
          className="clsw3-2"
          d="M1851.2 969.26c5.23-2.23 48.76-21.45 50.89-54.59.13-2.04 1.16-21.88-10.32-27.65-10.87-5.46-26.94 4.71-34.66 12.72-23.12 24.01-7.25 66.07-5.9 69.51Z"
        />
        <path
          className="clsw3-1"
          d="M1851.05 969.19c2.59-4.91 24.8-45.76 59.29-46.06 2.13-.02 22.76.03 28.14 11.37 5.09 10.74-6.3 25.66-15.01 32.66-26.11 20.98-68.91 3.51-72.41 2.03Z"
        />
        <ellipse
          className="clsw3-2"
          cx={1858.75}
          cy={879.07}
          rx={4.27}
          ry={4.11}
          transform="rotate(-.82 1864.25 881.89)"
        />
        <ellipse
          className="clsw3-2"
          cx={1916.89}
          cy={906.49}
          rx={4.27}
          ry={4.11}
          transform="rotate(-.82 1922.753 908.862)"
        />
        <ellipse
          className="clsw3-2"
          cx={1897.47}
          cy={873.86}
          rx={4.27}
          ry={4.11}
          transform="rotate(-.82 1903.419 876.58)"
        />
        <path
          className="clsw3-1"
          d="M147.67 1245.16c-2.69-4.85-25.78-45.12-59.37-43.01-2.07.13-22.16 1.64-26.99 13.63-4.57 11.35 7.04 25.84 15.78 32.4 26.17 19.65 67.23-1.26 70.59-3.02Z"
        />
        <path
          className="clsw3-2"
          d="M147.82 1245.07c1.14-5.57 10.12-52.3-15.92-72.91-1.6-1.27-17.33-13.41-28.61-7.25-10.67 5.83-11.46 24.83-9.27 35.74 6.58 32.68 50.2 43.57 53.8 44.42Z"
        />
        <path
          className="clsw3-1"
          d="M147.67 1245.16c-2.57-4.92-23.51-46.44-4.13-74.97 1.19-1.76 12.98-18.69 25.37-16.66 11.72 1.93 17.51 19.78 18.31 30.93 2.38 33.41-36.34 58.66-39.55 60.69Z"
        />
        <ellipse
          className="clsw3-2"
          cx={77.96}
          cy={1187.53}
          rx={4.27}
          ry={4.11}
          transform="rotate(-56.13 77.944 1187.498)"
        />
        <ellipse
          className="clsw3-2"
          cx={133.6}
          cy={1155.34}
          rx={4.27}
          ry={4.11}
          transform="rotate(-56.13 133.577 1155.303)"
        />
        <ellipse
          className="clsw3-2"
          cx={95.71}
          cy={1152.73}
          rx={4.27}
          ry={4.11}
          transform="rotate(-56.13 95.69 1152.7)"
        />
        {children}
      </g>
    </svg>
  );
}
